import axios from "axios";
import ErrorParser from '../error.parser';

const ConvertedService = {
  networks: async function () {
    const requestData = {
      method: "get",
      url: "/api/processing/converted/networks",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  units: async function () {
    const requestData = {
      method: "get",
      url: "/api/processing/converted/units",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  converted_timeseries: async function (net_id) {
    const requestData = {
      method: "post",
      url: "/api/processing/converted/converted_timeseries",
      data: {
        net_id: net_id
      }
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      let message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  insert: async function (converted_timeserie) {
    const requestData = {
      method: "post",
      url: "/api/processing/converted/insert",
      data: converted_timeserie
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },  
  update: async function (converted_timeserie) {
    const requestData = {
      method: "post",
      url: "/api/processing/converted/update",
      data: converted_timeserie
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  delete: async function (id) {
    const requestData = {
      method: "post",
      url: "/api/processing/converted/delete",
      data: { id: id }
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  }
};

export default ConvertedService;
